import { api } from "./api";
import { ENDPOINTS } from "./endpoints";
import { operations } from "types/openapi";

type getReportByIdOperation = operations["getById_1"];
type downloadFileOperation = operations["getAllRulesFiles"];
type deleteRulesDoc = operations["deleteRulesDoc"];
type uploadRulesFile = operations["uploadRulesFile"];

/**
 * Скачать файл с правилами (доступно для всех ролей)
 */
export const getRuleFiles = (): Promise<downloadFileOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.rulesFile());
};

/**
 * Получить отчет по ID (доступно для OPERATOR)
 */
export const getReportById = ({
  id,
}: getReportByIdOperation["parameters"]["path"]): Promise<
  getReportByIdOperation["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.reportById(id));
};

/**
 * Создать пользовательский отчет (доступно для OPERATOR)
 */
export const createReport = (
  date: string | Record<string, any>,
  reportType: string,
  customEndpoint?: string
): Promise<string> => {
  return api.post(customEndpoint ? customEndpoint : ENDPOINTS.generateReport(reportType), date, {
    contentType: "multipart/form-data",
  });
};

/**
 * Удаление файла с правилами платформы по его id из базы и S3
 */
export const deleteRuleFile = ({
  id,
}: deleteRulesDoc["parameters"]["path"]): Promise<deleteRulesDoc["responses"]["200"]["content"]> => {
  return api.del(ENDPOINTS.deleteRuleDoc(id));
};

/**
 * Загрузить документ c правилами платформы (OPERATOR)
 */
export const uploadRuleFile = ({
  file,
}: {
  file: FormData;
}): Promise<uploadRulesFile["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.uploadRuleDoc(), file);
};
